import React from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../lib/auth";

// Redirige vers /signin si l'utilisateur n'est pas connecté
export default function ProtectedRoute({ children }) {
  return isAuthenticated() ? children : <Navigate to="/signin" replace />;
}
